<template>
  <div>
    Survey
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>